import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import numeral from "numeral";
import { mapGetters } from "vuex";
import { getFullNameWithSalutationFrom, removeEmptyKeys } from "@Shared/utils/utils";
import Amplitude from "../../../../../../../shared/utils/amplitude";
import { get, isEmpty, upperFirst } from "lodash";
import ApplicationMixin from "../../../../../mixins/application/broker-application-navigation-mixin";
import { GET_REFERRAL_API_PARTNERS } from "@Broker/@Modules/main/store/account/account-getters";
import { defineComponent } from "@vue/composition-api";
import { CO_BROKERED_MORTGAGES } from "../store/application-getters";
export default defineComponent({
  name: "ApplicationDropdownNavigation",
  mixins: [ApplicationMixin],
  props: {
    page: {
      type: String,
      required: true
    },
    application: {
      type: Object,
      required: true
    },
    editVisibility: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      activeGroup: 0,
      activePage: 1
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapGetters("AccountStore", [GET_REFERRAL_API_PARTNERS])), mapGetters("ApplicationStore", ["allOtherProperties", CO_BROKERED_MORTGAGES])), {}, {
    allowForExistingMortgages() {
      const allowedFlows = ["refinance-approval", "switch-transfer"];
      const isAllowedFlow = _includesInstanceProperty(allowedFlows).call(allowedFlows, this.application.flow);
      const hasCoBrokeredMortgages = !isEmpty(this.CO_BROKERED_MORTGAGES);
      return isAllowedFlow || hasCoBrokeredMortgages;
    },
    hasReferralPartners() {
      const referralApiPartners = this.GET_REFERRAL_API_PARTNERS;
      return !isEmpty(referralApiPartners);
    },
    sections() {
      return {
        applicant: [{
          key: "personal-details",
          label: this.$t("application.pages.navigation-tabs.personal-details"),
          multi: false,
          active: true
        }, {
          key: "identifications",
          label: this.$t("application.pages.navigation-tabs.identifications"),
          multi: true
        }, {
          key: "addresses",
          label: this.$t("application.pages.navigation-tabs.addresses"),
          path: "personal-details][addresses",
          multi: true
        }, {
          key: "employment",
          label: this.$t("application.pages.navigation-tabs.employment"),
          multi: true
        }, {
          key: "other-income",
          label: this.$t("application.pages.navigation-tabs.other-income"),
          multi: true
        }, {
          key: "assets",
          label: this.$t("application.pages.navigation-tabs.assets"),
          multi: true
        }, {
          key: "liabilities",
          label: this.$t("application.pages.navigation-tabs.liabilities"),
          multi: true
        }, {
          key: "other-properties",
          label: this.$t("application.pages.navigation-tabs.other-properties"),
          multi: true
        }],
        property: [{
          key: "address",
          label: this.$t("application.pages.navigation-tabs.address"),
          multi: false,
          active: true
        }, {
          key: "mls-info",
          label: this.$t("application.pages.navigation-tabs.mls-info"),
          multi: false
        }, {
          key: "details",
          label: this.$t("application.pages.navigation-tabs.details"),
          multi: false
        }, {
          key: "taxes",
          label: this.$t("application.pages.navigation-tabs.taxes"),
          multi: false,
          active: true
        }, {
          key: "occupancy",
          label: this.$t("application.pages.navigation-tabs.occupancy"),
          multi: false
        }, {
          key: "fees",
          label: this.$t("application.pages.navigation-tabs.fees"),
          multi: false
        }, {
          key: "value",
          label: this.$t("application.pages.navigation-tabs.value"),
          multi: false
        }, this.allowForExistingMortgages ? {
          key: "existing-mortgages",
          label: this.$t("application.pages.navigation-tabs.existing-mortgages"),
          multi: true
        } : {}],
        "other-properties": [],
        "mortgage-details": [{
          key: "down-payment",
          label: this.$t("application.pages.navigation-tabs.down-payment"),
          multi: true,
          active: true
        }, {
          key: "mortgage-details",
          label: this.$t("application.pages.navigation-tabs.closing-details"),
          multi: false
        }, this.editVisibility ? {} : {
          key: "submission-details",
          label: this.$t("application.pages.navigation-tabs.submission-details"),
          ignorePage: true,
          multi: true
        }]
      };
    },
    pages() {
      return {
        "main-applicant": {
          label: this.$t("application.pages.navigation-tabs.main-applicant"),
          section: "applicant",
          key: "main-applicant"
        },
        "co-applicants": {
          label: this.$t("application.pages.navigation-tabs.co-applicants"),
          section: "applicant",
          key: "co-applicants"
        },
        property: {
          label: this.$t("application.pages.navigation-tabs.subjectProperty"),
          key: "property"
        },
        "mortgage-details": {
          label: this.$t("application.pages.navigation-tabs.mortgage-details"),
          key: "mortgage-details"
        }
      };
    },
    customApplication() {
      return _objectSpread(_objectSpread({}, this.application), {}, {
        "other-properties": this.allOtherProperties
      });
    },
    menu() {
      const menuItems = [];
      const {
        coapp
      } = this.application["main-applicant"]["personal-details"];
      const hasCoApplicant = coapp == null || coapp === true || coapp === "true";
      const hideApplicantCondition = this.editVisibility || !hasCoApplicant;
      const oneCoappEmpty = isEmpty(removeEmptyKeys(this.application["co-applicants"][0]));
      for (const page in this.pages) {
        if (page === "co-applicants") {
          if (hideApplicantCondition || oneCoappEmpty) continue;
        }
        const multi = this.isMultiPage(page);
        menuItems.push({
          page: _objectSpread({}, this.pages[page]),
          sections: !multi ? this.getSections(page) : this.getPageItems(page)
        });
      }
      return menuItems;
    },
    pageContainer() {
      return this.editVisibility ? "#page" : "#app-data-container";
    }
  }),
  watch: {
    page(value) {
      if (value) {
        Amplitude.logEvent(`Broker Application - application ${value} visited`);
      }
    }
  },
  beforeMount() {
    Amplitude.logEvent(`Broker Application - application ${this.page} visited`);
  },
  methods: {
    arrayLength(array, minLength = -1) {
      if (!array) return false;
      const length = array.length;
      return length > minLength;
    },
    handlePageChange(key) {
      var _context;
      if (_includesInstanceProperty(_context = this.mergedPages).call(_context, key)) {
        this.navigateTo(`#${key}-container`, 500, this.pageContainer);
        this.$emit("page-change", key, {
          scrollTop: false
        });
      } else this.$emit("page-change", key);
    },
    isMultiPage(page) {
      return Array.isArray(this.customApplication[page]);
    },
    superPath(page, index) {
      const item = this.customApplication[page][index];
      if (page === "other-properties") {
        return item.applicantIndex > 0 ? `co-applicants[${item.applicantIndex - 1}]` : "main-applicant";
      }
      return "";
    },
    getSections(page, index) {
      let sections = this.sections[page];
      if (page === "main-applicant" || page === "co-applicants") {
        sections = this.sections.applicant;
      }
      return _mapInstanceProperty(sections).call(sections, section => _objectSpread(_objectSpread({}, section), {}, {
        key: `${this.superPath(page, index)}${this.superPath(page, index) ? `[${page}]` : page}${index != null ? `[${index}]` : ""}[${section.path || section.key}]`,
        groups: this.getSectionGroups(section, page, index)
      }));
    },
    getPageItems(page) {
      var _context2, _context3;
      const {
        customApplication,
        pages: allPages
      } = this;
      if (!this.isMultiPage(page)) return [];
      const pageData = customApplication[page];
      const onlyPrimaryCoApplicant = page === "co-applicants" && pageData.length === 1;
      const onlyOneAdditionalCoApplicant = page === "co-applicants" && pageData.length < 3;
      if (onlyPrimaryCoApplicant) {
        return [];
      }
      if (onlyOneAdditionalCoApplicant) {
        return this.getSections(page, 1);
      }
      return _filterInstanceProperty(_context2 = _mapInstanceProperty(_context3 = customApplication[page]).call(_context3, (_, index) => ({
        key: page === "other-properties" ? this.getOtherPropertiesKey(index) : `${this.superPath(page, index)}${this.superPath(page, index) ? `[${page}]` : page}[${index}]`,
        label: page === "co-applicants" && this.coApplicantName(index) ? this.coApplicantName(index) : `${this.$options.filters.formatNumeral(index + 1, "0o")} ${pluralize(allPages[page].label, 1)}`,
        sections: this.getSections(page, index)
      }))).call(_context2, (_, index) => page === "co-applicants" ? index !== 0 : true);
    },
    getOtherPropertiesKey(index) {
      const currentProperty = this.allOtherProperties[index];
      const superPath = currentProperty.applicantIndex > 0 ? `co-applicants[${currentProperty.applicantIndex - 1}]` : "main-applicant";
      return `${superPath}[other-properties][${currentProperty.propertyIndex}]`;
    },
    getSectionGroups(section, page, index) {
      var _get;
      const {
        customApplication
      } = this;
      if (!section.multi || !customApplication[page]) return [];
      const pathToUse = this.getPathToUseInSection(section, page, index, this.isMultiPage(page));
      const appPath = (_get = get(customApplication, pathToUse)) != null ? _get : [];
      return _mapInstanceProperty(appPath).call(appPath, (item, appPathIndex) => {
        const label = this.getSectionLabel(pathToUse, item, section, appPathIndex);
        const indexToUse = appPathIndex;
        const keyToUse = this.getSectionKeyToUse(page, pathToUse, indexToUse, item);
        return {
          key: keyToUse,
          label
        };
      });
    },
    getSectionKeyToUse(page, pathToUse, indexToUse, item) {
      return `${this.superPath(page, item.applicantIndex)}${pathToUse}${indexToUse != null ? `[${indexToUse}]` : ""}`;
    },
    getSectionLabel(pathToUse, item, section, appPathIndex) {
      const ordinalLabel = `${numeral(appPathIndex + 1).format("0o")} ${pluralize(section.label, 1)}`;
      if (_includesInstanceProperty(pathToUse).call(pathToUse, "other-properties")) {
        var _item$propertyDetail, _item$propertyDetail$;
        return this.$options.filters.truncateText((_item$propertyDetail = item["property-details"]) == null ? void 0 : (_item$propertyDetail$ = _item$propertyDetail["address"]) == null ? void 0 : _item$propertyDetail$.line1, 20) || ordinalLabel;
      }
      if (pathToUse === "submission-details") {
        return `${upperFirst(item["submission-details"]["mortgage-type"])} ${pluralize(section.label, 1)}`;
      }
      return ordinalLabel;
    },
    handleHover(key) {
      this.$nextTick(() => {
        $(".dropdown-menu").dropdown("hide");
        $(this.$refs[key]).dropdown("show");
      });
    },
    handleLeave() {
      this.$nextTick(() => {
        $(".dropdown-menu").dropdown("hide");
      });
    },
    handleSectionNavigation(page, section, subSection) {
      var _context4, _context5;
      const element = `${subSection != null ? subSection : section}`;
      const hash = `#${this.$options.filters.hashId(element)}`;
      Amplitude.logEvent(`Broker Application - navigated to section ${section} in ${page} tab`, {
        element
      });
      const changingToMergedPages = _includesInstanceProperty(_context4 = this.mergedPages).call(_context4, page) && _includesInstanceProperty(_context5 = this.mergedPages).call(_context5, this.page);
      if (page !== this.page && !changingToMergedPages) {
        this.handlePageChange(page);
        this.$nextTick(() => {
          this.navigateTo(hash, 1000, this.pageContainer);
        });
        return;
      }
      this.navigateTo(hash, 500, this.pageContainer);
    },
    coApplicantName(index) {
      const {
        "personal-details": personalDetails
      } = this.customApplication["co-applicants"][index];
      return getFullNameWithSalutationFrom(personalDetails);
    },
    getPathToUseInSection(section, page, index, isMultiPage) {
      const {
        key,
        ignorePage,
        path
      } = section;
      if (ignorePage) {
        return key;
      }
      return isMultiPage ? `${page}[${index}][${path || key}]` : `${page}[${path || key}]`;
    }
  }
});